import type { ToggleProps } from "@components/contracts/Toggle.types";
import type React from "react";
import { Toggle as RsToggle } from "rsuite";

export const RsuiteToggle: React.FC<ToggleProps> = ({ onChange, ...props }) => (
  <RsToggle {...props} onChange={(checked) => onChange?.(checked)} />
);
